import { render, staticRenderFns } from "./other-games.vue?vue&type=template&id=1de80518&scoped=true&"
import script from "./other-games.vue?vue&type=script&lang=js&"
export * from "./other-games.vue?vue&type=script&lang=js&"
import style0 from "./other-games.vue?vue&type=style&index=0&id=1de80518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de80518",
  null
  
)

export default component.exports